import { IActionPayload } from 'spw-redux/types';
import {
  SET_PROJECT_SETTINGS,
  FETCH_PROJECT_SETTINGS_SUCCEEDED,
} from './actions';
import { ISettingsState, RatioCalculationType } from './types';

const initialState: ISettingsState = {
  projectSettings: {
    fileCabinetRatioCalculationType: RatioCalculationType.WORK_SEATS,
    lockerRatioCalculationType: RatioCalculationType.WORK_SEATS,
  },
};
const reducer = (
  state: ISettingsState = initialState,
  action: IActionPayload
) => {
  switch (action.type) {
    case SET_PROJECT_SETTINGS:
    case FETCH_PROJECT_SETTINGS_SUCCEEDED:
      return {
        ...state,
        projectSettings: {
          ...state.projectSettings,
          ...action.payload.projectSettings,
        },
      };
    default:
      return state;
  }
};

export default reducer;
